import { Component, OnInit } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { GridMetadataService } from '../clearwave-grid/grid.metadata.service';
import { environment } from "environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { LookupService } from 'app/webservice/lookup.service';

@Component({
  selector: 'print-spine-label',
  templateUrl: './print-spine-label.component.html',
  styleUrls: ['./print-spine-label.component.css']
})
export class PrintSpineLabelComponent implements OnInit {
  
  public labels;
  
  constructor(
    private route: ActivatedRoute, 
    private _lookup: LookupService,
    private _restService: RestService, 
    private _gridMetadataService: GridMetadataService,
    private _router: Router
  ) {
      
    this.route.params.subscribe(params => {
      if (params['rows']) {
        let list = params['rows'].split(',');
        for (let i = 0; i < list.length; i++) {
          let a = list[i].split(" ", 5);

          switch(a.length) {
            case 1 :
                list[i] = a[0];
                break;
            case 2:
                list[i] = a[0] + "\r\n" + a[1];
                break;
            case 3:
                list[i] = a[0] + "\r\n" + a[1] + "\r\n" + a[2];
                break;
            case 4:
                list[i] = a[0] + "\r\n" + a[1] + "\r\n" + a[2] + " " + a[3];
                break;
            case 5:
                list[i] = a[0] + "\r\n" + a[1] + "\r\n" + a[2] + " " + a[3] + " " + a[4];
                break;            
            default:
                list[i] = "";
          }
        }

        this.labels = list;
        window.setTimeout(() => {
          window.print();
        },500)
      }
    });

    
  }

  ngOnInit() {
  
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/print-spine-label/print-spine-label.component.ts